<script lang="ts" setup>
import Link1 from '@/components/Button/Link1.vue'
import { useArticleStore } from '@/stores'

const articleStore = useArticleStore()
const newsTop = computed(() => articleStore.getNewsTops.length > 0 ? articleStore.getNewsTops[0] : null)
const linkStr = computed(() => `/news/article/${newsTop.value?.seo?.meta_slug || newsTop.value?.id}`)

const isShow: Ref<boolean> = ref(false)
onMounted(() => {
  isShow.value = true
})
</script>

<template>
  <div class="pin" :class="{ isShow: isShow }" v-if="newsTop !== null">
    <figure class="pin__pic">
      <nuxt-link :to="linkStr">
        <Nimg :src="newsTop.image?.link" :title="newsTop.image?.title" :alt="newsTop.image?.alt" />
      </nuxt-link>
    </figure>
    <div class="pin__item">
      <Date :date="newsTop.publish_date" class="pin__date" />
      <nuxt-link :to="linkStr" class="pin__title" :title="newsTop.subject">
        {{ newsTop.subject }}
      </nuxt-link>
    </div>
    <div class="pin__link">
      <Link1 :to="linkStr" title="閱讀" color="gray-3" class="swiper-list__link">閱讀</Link1>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.pin {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  column-gap: toRem(24);
  margin-bottom: toRem(135);

  @include max-media(640) {
    margin-bottom: toRem(90);
  }

  @include min-media(641) {
    grid-template-areas:
      'pic pic pic pic . .  link link'
      '. . . . item item item  .';
  }

  @include max-media(640) {
    grid-template-columns: repeat(4, 1fr);
  }

  &__pic {
    // grid-column: 1 / span 4;
    position: relative;
    padding-top: 100%;
    background-color: $color-white-2;
    overflow: hidden;

    @include min-media(641) {
      grid-area: pic;
    }

    @include max-media(640) {
      grid-row: 1;
      grid-column: 1 / span 4;
      margin-bottom: toRem(15);
    }

    img {
      position: absolute;
      left: 0;
      top: 0;
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      transform: scale(1.05);
      opacity: 0;
      transition: all 0.5s ease-in-out;
    }
  }

  &__item {
    margin-top: auto;

    @include min-media(641) {
      grid-area: item;
    }

    @include max-media(640) {
      grid-row: 2;
      grid-column: 1 / span 4;
    }
  }

  &__link {
    display: flex;
    justify-content: flex-end;
    margin-top: auto;

    @include min-media(641) {
      grid-area: link;
    }

    @include max-media(640) {
      grid-row: 3;
      grid-column: 1 / span 4;
    }
  }

  &__title {
    display: block;
    font-size: toRem(20);
    @include dot-many-line(2);
  }

  &__date,
  &__title,
  &__link {
    transform: translateY(toRem(15));
    opacity: 0;
    transition: all 0.5s ease-in-out;
  }

  &.isShow {
    .pin {
      &__pic {
        img {
          opacity: 1;
          transform: scale(1);
          transition-delay: 0.2s;
        }
      }

      &__date,
      &__title,
      &__link {
        transform: translateY(toRem(0));
        opacity: 1;
        transition: all 0.8s ease-in-out;
      }

      &__date {
        transition-delay: 0.3s;
      }

      &__title {
        transition-delay: 0.4s;
      }

      &__link {
        transition-delay: 0.5s;
      }
    }
  }
}
</style>
